import {ITipoOrdenBalanza} from './../modelos/ITipoOrdenBalanza';
import {Observable} from 'rxjs';
import {CommonService} from './../../../shared/utils/common.service';
import {UtilsService} from './../../../shared/utils/utils.service';
import {Injectable} from '@angular/core';
import {moduloGaritas} from '../diccionarios/balanzaModulo.js';

@Injectable({
  providedIn: 'root',
})
export class TipoOrdenesBalanzaService {
  private diccionarioModulo: any;
  private url: string;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloGaritas;
    this.url = this._util.getUrlBascula();
  }

  obtener(): Observable<any[]> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.tipoOrdenBalanza.obtenerTodo
    );
  }

  obtenerPorId(idGarita: number): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url +
      this.diccionarioModulo.url.tipoOrdenBalanza.obtenerPorId +
      idGarita
    );
  }

  crear(request: ITipoOrdenBalanza) {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.tipoOrdenBalanza.crear,
      request
    );
  }

  actualizar(request: ITipoOrdenBalanza): Observable<any> {
    return this._commom.peticionPutConHeader(
      this.url + this.diccionarioModulo.url.tipoOrdenBalanza.actualizar,
      request
    );
  }

  borrar(idGarita: number): Observable<any> {
    return this._commom.peticionDeleteConHeader(
      this.url + this.diccionarioModulo.url.tipoOrdenBalanza.eliminar + idGarita
    );
  }
}
